export const APP_CONFIG = {
  MEMBERSHIP_ENABLED: true, // 🔴 turn ON/OFF here
};